function $(sel, root){ return (root || document).querySelector(sel); }
function onReady(fn){ if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, {once:true}); else fn(); }

function initViewToggle(){
  var container = document.getElementById('ProductGridContainer');
  if (!container) return;

  function getGridEl(){
    return document.getElementById('product-grid')
        || container.querySelector('#product-grid')
        || container.querySelector('.grid')
        || null;
  }

  var gridEl = getGridEl();
  var collectionEl = container.querySelector('.collection') || document.querySelector('.collection.page-width, .collection');
  if (!gridEl && !collectionEl) return;

  var allBtns = Array.from(document.querySelectorAll('.collection-view-toggle .view-btn'));
  var selects  = Array.from(document.querySelectorAll('#ViewModeSelect'));
  if (!allBtns.length && !selects.length) return;

  function setPressedState(mode){
    allBtns.forEach(function(b){
      var on = b.dataset.view === mode;
      b.classList.remove('is-active','active');
      if (on) b.classList.add('is-active');
      b.setAttribute('aria-pressed', String(on));
    });
    selects.forEach(function(sel){ if (sel.value !== mode) sel.value = mode; });
  }

  function applyView(view){
    var isList = view === 'list';
    var targets = [];
    var fresh = getGridEl();
    if (fresh) gridEl = fresh;
    if (gridEl) targets.push(gridEl);
    if (collectionEl && targets.indexOf(collectionEl) === -1) targets.push(collectionEl);
    targets.forEach(function(el){
      el.classList.toggle('view--list', isList);
      el.classList.toggle('view--grid', !isList);
    });
    setPressedState(view);
    localStorage.setItem('collectionView', view);
    var url = new URL(window.location);
    url.searchParams.set('view', view);
    window.history.replaceState({}, '', url);
  }

  var params    = new URLSearchParams(window.location.search);
  var paramView = params.get('view');
  var saved     = localStorage.getItem('collectionView');
  var initial   = (paramView === 'grid' || paramView === 'list') ? paramView : (saved || 'grid');
  applyView(initial);

  allBtns.forEach(function(btn){
    btn.addEventListener('click', function(e){
      var mode = btn.dataset.view === 'list' ? 'list' : 'grid';
      applyView(mode);
      btn.blur();
    });
  });
  selects.forEach(function(sel){
    sel.addEventListener('change', function(){ applyView(sel.value); });
  });

  var mo = new MutationObserver(function(){
    var mode = localStorage.getItem('collectionView') || 'grid';
    applyView(mode);
  });
  mo.observe(container, { childList: true, subtree: true });
}

function initListCards(root){
  (root || document).querySelectorAll('.card-list').forEach(function(card){
    if (card.__initialized) return;
    card.__initialized = true;

    var form = card.querySelector('form.card-list__form');
    if (!form) return;

    var radios = Array.from(form.querySelectorAll('input[type="radio"][name="id"]'));
    var select = form.querySelector('select[name="id"]');

    var qtyInput = form.querySelector('.qty-input');
    var minus = form.querySelector('[data-qty-minus]');
    var plus  = form.querySelector('[data-qty-plus]');
    minus && minus.addEventListener('click', function(){
      var n = Math.max(1, (parseInt(qtyInput.value||'1',10) - 1));
      qtyInput.value = n;
    });
    plus && plus.addEventListener('click', function(){
      var n = (parseInt(qtyInput.value||'1',10) + 1);
      qtyInput.value = n;
    });

    var priceEl = form.querySelector('[data-price]');
    var compareEl = form.querySelector('[data-compare]');
    var data = (function(){
      try { return JSON.parse(form.querySelector('.variant-data-json').textContent); }
      catch(e){ return []; }
    })();

    function updatePrice(variantId){
      var row = data.find(function(x){ return String(x.id) === String(variantId); });
      if (!row || !priceEl) return;
      priceEl.textContent = row.price;
      if (compareEl){
        if (row.compare && row.compare !== '0') {
          compareEl.textContent = row.compare;
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      var atc = form.querySelector('.card-list__atc');
      if (atc) atc.disabled = !row.available;
    }

    function refreshActive(){
      radios.forEach(function(r){
        var li = r.closest('li');
        if (li) li.classList.toggle('is-active', r.checked);
      });
    }

    if (radios.length){
      radios.forEach(function(r){
        r.addEventListener('change', function(){
          updatePrice(r.value);
          refreshActive();
        });
      });
      var checked = radios.find(function(r){ return r.checked; });
      if (checked) updatePrice(checked.value);
      refreshActive();
    } else if (select){
      select.addEventListener('change', function(){ updatePrice(select.value); });
      if (select.value) updatePrice(select.value);
    }
  });
}

function attachObservers(){
  var container = document.getElementById('ProductGridContainer');
  if (!container) return;

  var mo = new MutationObserver(function(){
    initViewToggle();
    initListCards(container);
  });
  mo.observe(container, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', function(){
    initViewToggle();
    initListCards();
  });
}

onReady(function(){
  initViewToggle();
  initListCards();
  attachObservers();
});
